import { UserLevel } from "utils/constant";
import { monthListObject } from "utils/common";

const MONTHLY_CHART_LEVELS = [UserLevel.Fasyankes, UserLevel.BKKWilker];

export const formatKelengkapanPeriodLabel = (name, level) => {
  if (!MONTHLY_CHART_LEVELS.includes(level)) {
    return name;
  }

  const monthName = monthListObject.find(
    (item) => item.value === String(name).padStart(2, "0"),
  )?.label;

  return monthName || name;
};

// Baris tanpa `dates` (mis. payload indikator_20) bukan deret waktu, jadi tidak
// disaring periode. Baris ber-`dates` disaring persis seperti perilaku sebelumnya.
export const filterRowsInPeriod = (rows, period) => {
  if (!Array.isArray(rows)) return [];
  if (period === "Bulanan") {
    return rows.filter((item) => {
      if (!item?.dates) return true;
      const m = parseInt(item.dates.split("-")[1], 10);
      return m >= 1 && m <= 12;
    });
  }
  if (period === "Mingguan") {
    return rows.filter((item) => {
      if (!item?.dates) return true;
      const w = parseInt(item.dates.split("-")[1], 10);
      return w >= 1 && w <= 53;
    });
  }
  return rows;
};

// `01-08-2025 - 07-08-2025` -> ["2025-08-01", "2025-08-07"]; label rusak -> [].
export const weeklyRangeToIso = (range) => {
  const parts = String(range || "").split(" - ");
  if (parts.length !== 2) return [];
  const toIso = (label) => {
    const [day, month, year] = String(label).trim().split("-");
    const d = parseInt(day, 10);
    const mo = parseInt(month, 10);
    const y = parseInt(year, 10);
    if (!y || String(year).length !== 4 || d < 1 || d > 31 || mo < 1 || mo > 12) {
      return null;
    }
    return `${year}-${String(mo).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
  };
  const start = toIso(parts[0]);
  const end = toIso(parts[1]);
  return start && end ? [start, end] : [];
};

export const toDeathSeries = (row = {}) => ({
  total: Number(row?.death) || 0,
  withMalaria: Number(row?.death_with_malaria) || 0,
  // akibat malaria yang belum terhitung sebagai kematian dengan malaria,
  // supaya total segmen stacked sama dengan total unik
  causedOnly: Math.max(
    (Number(row?.death) || 0) - (Number(row?.death_with_malaria) || 0),
    0,
  ),
  causedByMalaria: Number(row?.death_caused_by_malaria) || 0,
});
